import React from 'react';
import ReactSlider from 'react-slider';
import cn from 'classnames';

export const CustomRangeSlider = ({
  key,
  showTooltips = true,
  labels = ['Allow', 'Pending', 'Blocked'],
  colors = {
    thumbs: {
      first: 'bg-success',
      middle: 'bg-indigo-500',
      last: 'bg-status-404',
    },
    tooltips: {
      first: 'bg-success',
      middle: 'bg-gray-500',
      last: 'bg-[#4A4A68]',
    },
    pointers: {
      first: 'after:border-b-success',
      middle: 'after:border-b-[#4A4A68]',
      last: 'after:border-b-[#4A4A68]',
    },
    tracks: {
      first: 'bg-success',
      middle: 'bg-[#4A4A68]',
      last: 'bg-status-404',
      single: 'bg-gray-300',
    },
  },
  ariaLabels = ['Allow', 'Pending', 'Blocked'],
  ..._props
}) => {
  const isVertical = _props.orientation === 'vertical';

  return (
    <>
      <div className="absolute bottom-[2px] left-[-6px] h-[12px] z-[9] w-[12px] flex items-center bg-[#D2D2D2] rounded-full aspect-square cursor-not-allowed" />
      <div
        className={`cursor-not-allowed ${colors.tooltips.first} absolute bottom-[19px] -left-[11px] px-[8px] py-[3px] text-white text-[8px] rounded after:content-[''] after:absolute after:block after:w-0 after:h-0 after:border-l-transparent after:border-l-4 after:border-b-4 after:border-r-transparent after:border-r-4 after:rotate-180 after:left-1/2 after:-translate-x-1/2 after:-bottom-[3px] after:border-b-status-404`}
      >
        0
      </div>
      <ReactSlider
        {..._props}
        // pearling
        ariaLabel={['Allow', 'Pending', 'Blocked']}
        renderThumb={(props, state) => {
          const isFirstThumb = state.index === 0;
          const isLastThumb = state.index === state.value.length - 1;
          const thumbColor = isFirstThumb
            ? colors.thumbs.first
            : isLastThumb
            ? colors.thumbs.last
            : colors.thumbs.middle;

          const tooltipBackground = isFirstThumb
            ? colors.tooltips.first
            : isLastThumb
            ? colors.tooltips.last
            : colors.tooltips.middle;

          const pointerColorClass = isFirstThumb
            ? colors.pointers.first
            : isLastThumb
            ? colors.pointers.last
            : 'after:border-b-[#4A4A68]';

          const tooltipText = labels[state.index] || '';

          return (
            <div {...props} className="relative top-[2px] cursor-pointer">
              <div
                className={cn({
                  'aspect-square h-[12px] w-[12px] rounded-full bg-white text-xs text-white flex items-center justify-center cursor-grab px-1': true,
                  [thumbColor]: false,
                })}
              ></div>
              <div
                className={cn(
                  'absolute bottom-[118%] left-1/2 -translate-x-1/2 px-[5px] mb-[3px] py-[2px] w-fit text-white text-[8px] rounded',
                  "after:content-[''] after:absolute after:block after:w-0 after:h-0 after:border-l-transparent after:border-l-4 after:border-b-4 after:border-r-transparent after:border-r-4 after:rotate-180 after:left-1/2 after:-translate-x-1/2 after:-bottom-[3px]",
                  tooltipBackground,
                  pointerColorClass,
                )}
              >
                {isFirstThumb || isLastThumb ? state.valueNow : tooltipText}
              </div>
            </div>
          );
        }}
        renderTrack={(props, state) => {
          const points = Array.isArray(state.value) ? state.value.length : null;
          const isMulti = points && points > 0;
          const isLast = isMulti ? state.index === points : state.index !== 0;
          const isFirst = state.index === 0;

          // Calculate the track color based on the track index
          let trackColor;
          if (isMulti) {
            if (isFirst) trackColor = colors.tracks.first;
            else if (isLast) trackColor = colors.tracks.last;
            else trackColor = colors.tracks.middle;
          } else {
            trackColor = colors.tracks.single;
          }

          return (
            <div
              {...props}
              key={`${props?.id}-${trackColor}`}
              className={cn({
                'h-1/4 top-1/2 -translate-y-1/2': !isVertical,
                'w-1/4 left-1/2 -translate-x-1/2': isVertical,
                'rounded-full': true,
                'bg-gray-200': isMulti ? isFirst || isLast : isLast,
                [trackColor]: true,
              })}
            ></div>
          );
        }}
      />
      <div className="absolute bottom-[2px] right-[-6px] h-[12px] w-[12px] flex items-center bg-[#D2D2D2] rounded-full aspect-square cursor-not-allowed" />
      <div
        className={`cursor-not-allowed ${colors.thumbs.last} absolute bottom-[19px] right-[-9px] p-[2px] text-white text-[8px] rounded after:content-[''] after:absolute after:block after:w-0 after:h-0 after:border-l-transparent after:border-l-4 after:border-b-4 after:border-r-transparent after:border-r-4 after:rotate-180 after:left-1/2 after:-translate-x-1/2 after:-bottom-[3px] after:border-b-success`}
      >
        100
      </div>
    </>
  );
};
